import { createMockOfferResumeResponse } from './offer-resume.response.mock';
import { OfferResponse } from './offer.response';
export const createMockOfferResponse = (customValues) => {
    const offerResume = createMockOfferResumeResponse(customValues);
    const response = Object.assign(new OfferResponse(), offerResume);
    response.introduction = customValues?.introduction ?? 'introduction';
    response.responsibilities = customValues?.responsibilities ?? ['responsibility 1', 'responsibility 2'];
    response.whatOffering = customValues?.whatOffering ?? 'what offering';
    response.whenWillDoIt = customValues?.whenWillDoIt ?? 'when will do it';
    response.whereWillDoIt = customValues?.whereWillDoIt ?? 'where will do it';
    response.whoWillDoItWith = customValues?.whoWillDoItWith ?? 'who will do it with';
    response.whatWillYouDo = customValues?.whatWillYouDo ?? 'what will you do';
    response.howWillYouDoIt = customValues?.howWillYouDoIt ?? 'how will you do it';
    response.whatTheyAskFor = customValues?.whatTheyAskFor ?? 'what they ask for';
    response.inOneMonth = customValues?.inOneMonth ?? 'in one month';
    response.inThreeMonths = customValues?.inThreeMonths ?? 'in three months';
    response.inSixMonths = customValues?.inSixMonths ?? 'in six months';
    response.lastStatusChange = customValues?.lastStatusChange ?? new Date('2021-01-01T00:00:00Z');
    response.perks = customValues?.perks ?? [
        {
            id: 1,
            name: 'perk 1',
            description: 'perk 1 description',
            icon: { url: 'https://example.com/perk1.png', alt: 'perk 1 icon alt', filename: 'perk1.png', id: 1, title: 'perk 1 icon title' }
        }
    ];
    response.techs = customValues?.techs ?? [
        {
            name: 'tech 1',
            icon: { url: 'https://example.com/tech1.png', alt: 'tech 1 icon alt', filename: 'tech1.png', id: 1, title: 'tech 1 icon title' },
            level: 'BASIC',
            section: 'MUST',
            order: 1
        }
    ];
    response.softSkills = customValues?.softSkills ?? [
        {
            name: 'soft skill 1',
            description: 'soft skill 1 description',
            icon: {
                url: 'https://example.com/softskill1.png',
                alt: 'soft skill 1 icon alt',
                filename: 'softskill1.png',
                id: 1,
                title: 'soft skill 1 icon title'
            },
            section: 'MUST',
            order: 1
        }
    ];
    response.languages = customValues?.languages ?? [{ code: 'EN', name: 'English', level: 'Fluent' }];
    response.scout = customValues?.scout ?? {
        firstName: 'John',
        lastName: 'Doe',
        avatar: { url: 'https://example.com/avatar.png', alt: 'scout avatar alt', filename: 'avatar.png', id: 1, title: 'scout avatar title' },
        email: 'jon.doe@example.com'
    };
    response.faq = customValues?.faq ?? [
        { question: 'faq question 1', answer: 'faq answer 1' },
        { question: 'faq question 2', answer: 'faq answer 2' }
    ];
    response.watches = customValues?.watches;
    response.workingDayInfo = customValues?.workingDayInfo ?? {
        isFullTime: true,
        hasFlexTime: false,
        hasContinuousWorkDayOnFridays: true,
        hasContinuousWorkDayInSummer: false,
        annualHolidays: 22,
        schedules: [
            {
                name: 'schedule 1',
                text: 'schedule 1 text',
                bars: [
                    {
                        title: 'bar 1',
                        subtitle: 'bar 1 subtitle',
                        inOutFlexibleMinutes: 30,
                        ranges: [
                            {
                                startTime: '08:00',
                                endTime: '15:00',
                                isFreeTime: false
                            }
                        ]
                    }
                ]
            }
        ]
    };
    response.migratedToMarkdown = customValues?.migratedToMarkdown ?? false;
    return response;
};
//# sourceMappingURL=offer.response.mock.js.map